import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useForm } from './useForm'

export const useRegistration = () => {
  const navigate = useNavigate()
  const { registerWithEmail, isLoading } = useAuth()
  const [error, setError] = useState('')

  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    username: '',
    password: '',
    confirmPassword: ''
  }

  const handleSubmit = async (values) => {
    setError('')

    const result = await registerWithEmail(values)

    if (result.success) {
      navigate('/home')
    } else {
      setError(result.error)
    }
  }

  const clearError = () => setError('')

  const { values, handleChange, handleSubmit: onSubmit } = useForm(
    initialValues,
    handleSubmit,
    clearError
  )

  return {
    values,
    handleChange,
    handleSubmit: onSubmit,
    isLoading,
    error
  }
}